import React from "react";
import { useField, useFormikContext } from "formik";
import { TimePicker } from "antd";
import dayjs from 'dayjs';
const getFieldCSSClasses = (touched, errors) => {
  const classes = ["form-control"];
  if (touched && errors) {
    classes.push("is-invalid");
  }

  if (touched && !errors) {
    classes.push("is-valid");
  }

  return classes.join(" ");
};

export function TimePickerField({ ...props }) {
  const { setFieldValue, errors, touched } = useFormikContext();
  const [field] = useField(props);
  return (
    <>
      <div>{props.label && <label>{props.label}</label>}</div>
      <TimePicker
        needConfirm={false}
        className={getFieldCSSClasses(touched[field.name], errors[field.name])}
        style={{ width: "100%" }}
        showNow={false}
        format='hh:mm a'
        // placement='topLeft'
        // minuteStep={15}
        use12Hours={true}
        onChange={(value) => {
          setFieldValue(field.name, value.format("HH:mm"));
        }}
        value={field.value ? dayjs(field.value, "HH:mm") : ''}
      />
      {errors[field.name] && touched[field.name] ? (
        <div className="invalid-datepicker-feedback">
          {errors[field.name].toString()}
        </div>
      ) : null}
    </>
  );
}
